// import { handleCategoryNavigation } from "./routeFunctions";

let routes = [
  {
    path: "/lavora-con-noi",
    meta: {
      site: "site"
    },
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "",
        name: "WorkWithUs",
        meta: {
          site: "site",
          slug: "lavora-con-noi"
          // pageName: "leaflets"
        },
        component: () => import("@/views/store/WorkWithUs.vue")
      },
      // {
      //   path: "/lavora-con-noi/punti-vendita",
      //   name: "JobsList",
      //   meta: {
      //     site: "site",
      //     slug: "lavora-con-noi/punti-vendita"
      //   },
      //   component: () => import("@/views/store/JobsList.vue")
      // },
      // {
      //   path: "/lavora-con-noi/in-sede",
      //   name: "JobsList",
      //   meta: {
      //     site: "site",
      //     slug: "lavora-con-noi/in-sede"
      //   },
      //   component: () => import("@/views/store/JobsList.vue")
      // },
      // {
      //   path: "/lavora-con-noi/polo-logistico",
      //   name: "JobsList",
      //   meta: {
      //     site: "site",
      //     slug: "lavora-con-noi/polo-logistico"
      //   },
      //   component: () => import("@/views/store/JobsList.vue")
      // },
      {
        path: "/lavora-con-noi/invia-cv",
        name: "JobSendCv",
        meta: {
          site: "site"
        },
        component: () => import("@/views/store/JobSendCv.vue")
      },
      {
        path: "/lavora-con-noi/thank-you",
        name: "JobThankYouPage",
        meta: {
          site: "site"
        },
        component: () => import("@/views/store/JobThankYouPage.vue")
      },
      {
        path: "/lavora-con-noi/:storeId/",
        name: "JobsList",
        meta: {
          site: "site"
        },
        props: route => ({
          storeId: route.params.storeId
        }),
        component: () => import("@/views/store/JobsList.vue")
      },
      {
        path: "/lavora-con-noi/:storeId/:jobId",
        name: "JobDetail",
        meta: {
          site: "site"
        },
        props: route => ({
          jobId: route.params.jobId
        }),
        component: () => import("@/views/store/JobDetail.vue")
      }
    ]
  },
  {
    path: "/volantini",
    meta: {
      site: "site"
    },
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "",
        name: "Leaflets",
        meta: {
          site: "site",
          slug: "leaflet"
          // pageName: "leaflets"
        },
        component: () => import("@/views/catalog/Leaflets.vue")
      },
      {
        path: "/volantini/:leafletId",
        name: "Leaflet",
        meta: {
          site: "site"
          // slug: "leaflet"
        },
        props: route => ({
          leafletId: route.params.leafletId
        }),
        component: () => import("@/views/catalog/Leaflet.vue")
      },
      {
        path: "/volantini/:leafletId/lista",
        name: "LeafletList",
        meta: {
          site: "site"
          // ,
          // pageName: "leaflet-list"
        },
        props: route => ({
          leafletId: route.params.leafletId
        }),
        component: () => import("@/views/catalog/LeafletList.vue")
      }
    ]
  },
  {
    path: "/leaflet/:leafletId/:page",
    name: "LeafletProduct",
    meta: {
      site: "site"
    },
    props: route => ({
      productId: route.query.product_id,
      leafletId: route.params.leafletId,
      page: route.params.page
    }),
    component: () => import("@/views/catalog/LeafletProduct.vue")
  },
  {
    //gestione gerarchica del catalogo per poter gestire il reset filters all'ingresso.
    path: "/catalog",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    beforeEnter(to, from, next) {
      global.EventBus.$emit("resetFilters");
      next();
    },
    children: [
      {
        path: "/search",
        name: "Search",
        component: () => import("@/views/catalog/Search.vue"),
        meta: { slug: "search" },
        props: route => ({
          query: route.params,
          parent_category_id: route.params.parent_category_id,
          filter: route.params.filter,
          mode: "search"
        })
      },
      {
        path: "/fast-search",
        name: "FastSearch",
        component: () => import("@/views/catalog/FastSearch.vue"),
        props: route => ({
          query: route.query.q
        }),
        meta: { slug: "fast-search" }
      },

      {
        path: "/product/:slug",
        name: "Product",
        component: () => import("@/views/catalog/Product.vue"),
        props: route => ({
          slug: route.params.slug
        }),
        meta: {
          keepAlive: true,
          product: true
        }
      },
      {
        path: "/*",
        name: "Category",
        component: () => import("@/views/catalog/Category.vue"),
        meta: {
          keepAlive: true
        },
        //commento
        props: route => ({
          slug: route.params.pathMatch,
          categoryId: route.query.categoryId
        })
      }
    ]
  }
];

export default routes;
